<template lang="pug">
  theme-provider(:theme="theme")
    // step 0 product has opened repair request
    main.main.main_service-request(v-if="product.HAS_OPENED_REQUESTS")
      .main__header
        h1.main__title {{ $t('request.titles.reason') }}
        h2.main__subtitle(v-if="!product.GUARANTEE_PERIOD") {{ $t('request.subtitles.reason') }}
      .main__container
        .form.form_request.main__content
          | {{ $t('request.errors.product-has-opened-requests') }}
    // step 1 reason (title, description, files)
    main.main.main_service-request(v-else-if="step === 'reason'")
      .main__header
        h1.main__title {{ $t('request.titles.reason') }}
        h2.main__subtitle(v-if="!product.GUARANTEE_PERIOD") {{ $t('request.subtitles.reason') }}
      .main__container
        .form.form_request.main__content
          .form__row
            label.form__label {{ $t('request.labels.reason' )}}
            .form__field
              v-select(:options="options" label="title" v-model.trim="$v.reason.title.$model" class="custom-select")
                template(slot="option" slot-scope="option" class="custom-select__option") {{ option.title }}
          .form__row
            label.form__label {{ $t('request.labels.description') }}
            .form__field
              textarea.form__textarea(:placeholder="$t('request.placeholders.textarea')" v-model.trim="$v.reason.description.$model")
          .form__row
            Uploader(
              v-on:change-files="changeFiles"
            )
          footer.form__footer
            Checkbox(
              label="Я ознакомлен(-а) с <a href='/static/Dock_Service_Final.pdf' target='_blank'>Условиями гарантийного обслуживания</a>"
              v-on:handleChange="reason.agreement = !reason.agreement"
              :checked="reason.agreement",
              id="agreement"
            )
            button.button.button_padding.form__submit(
              :disabled="$v.reasonGroup.$invalid"
              @click="step = 'deliverySend'"
            ) {{ $t('request.buttons.continue') }}
    // step 2 where send device
    main.main.main__where-to-get(v-else-if="step === 'deliverySend'")
      .main__header
        h1.main__title {{ $t('request.titles.send') }}
      .main__container
        .main__content
          .form.form_where-to-get
            .form__row
              label.form__label {{ $t('request.send.label') }}
              .form__filed.form__field_row
                RadioButton(
                  value="np"
                  :label="$t('request.send.np.label')"
                  name="delivery"
                  :checked="receive_type === 'newpost'"
                  v-on:changeRadio="receive_type = 'newpost'"
                )
                RadioButton(
                  value="sho"
                  :label="$t('request.send.sho.label')"
                  name="delivery"
                  :checked="receive_type === 'showroom'"
                  v-on:changeRadio="receive_type = 'showroom'"
                )
                //div.disabled-delivery-button {{'Доставить самостоятельно в магазин ШО *Временно не доступно'}}
            .form__row
              h2.form__text.form__title
                .form__text-row
                  .form__text-row_1
                    //h3.form__text.form__text_bold {{ receive_type === 'newpost' ? $t('request.send.np.title') : $t('request.send.sho.title') }}
                    h3.form__text.form__text_bold {{ receive_type === 'newpost' ? $t('request.send.np.title') : ''}}
                    address.form__text.form__text_gray.form__address {{ receive_type === 'newpost' ? $t('request.send.np.address') : $t('request.send.sho.address') }}
                  .form__text-row_2
                    span.form__price.form__text.form__text_gray {{ receive_type === 'newpost' ? $t('request.send.np.price') : $t('request.send.sho.price' | '') }}
            .form__row(v-if="receive_type === 'showroom'")
              Checkbox(
                :label="$t('request.labels.checkbox')"
                v-on:handleChange="delivery_type = !delivery_type"
                :checked="delivery_type",
                id="back"
              )
            footer.form__footer
              a.link-back(@click="step = 'reason'") {{ $t('request.buttons.back') }}
              button.button.form__submit(@click="step = (receive_type === 'showroom' && delivery_type) ? 'contact' : 'delivery'") {{ (receive_type === 'showroom' && delivery_type) ? $t('request.buttons.continue') : $t('request.buttons.choseAddress') }}
    // step 3
    main.main.main__where-delivery(v-else-if="step === 'delivery'")
      header.main__header
        h1.main__title {{ $t('whereDelivery.title') }}
        h2.main__subtitle {{ $t('whereDelivery.subTitle') }}
      .main__container
        .main__content
          .form.form_where-delivery
            .form__row
              .form__label(v-html="$t('whereDelivery.labels.city')")
              .form__field
                v-select(:options="optionsCities" label="title" class="custom-select" :value="delivery.city" @input="setActiveCity" @search="citySearch" @open="cityOpen" @close="cityClose" :filterable="false")
                  template(slot="option" slot-scope="option" class="option") {{ option.title }}
                  template(slot="list-footer")
                    li(ref="cityLoad" class="loading" v-show="cityNextPage")
                  template(slot='no-options')
                    div(@mousedown.stop='')
                      | Извините, нет подходящих вариантов
              //span.form__error-text(v-if='$v.phrase.$error') {{ $t('whereDelivery.errors.city') }}
            .form__row
              label.form__label {{ $t('whereDelivery.labels.np') }}
              .form__field
                v-select(:options="paginatedWarehouses" label="title" :value='delivery.warenhouse' @search="warehouseSearch" @open="warehouseOpen" @close="warehouseClose" @input="setActiveNp" class="custom-select" :filterable="false")
                  template(slot="option" slot-scope="option" class="custom-select__option") {{ option.title }}
                  template(slot="list-footer")
                    li(ref="warehouseLoad" class="loading")
                  template(slot='no-options')
                    div(@mousedown.stop='')
                      | Извините, нет подходящих вариантов
            .form__row.form__row-first-name
              TextInput(
                :label="$t('whereDelivery.labels.firstName')"
                :error="$v.delivery.receiver_first_name.$error"
                :value="$v.delivery.receiver_first_name.$model"
                v-on:change-input="(e) => {changeInput('delivery', 'receiver_first_name', e)}"
                )
            .form__row.form__row-last-name
              TextInput(
                :label="$t('whereDelivery.labels.lastName')"
                :error="$v.delivery.receiver_last_name.$error"
                :value="$v.delivery.receiver_last_name.$model"
                v-on:change-input="(e) => {changeInput('delivery', 'receiver_last_name', e)}"
              )
            .form__row.form__row-middle-name
              TextInput(
                :label="$t('whereDelivery.labels.middleName')"
                :error="$v.delivery.receiver_middle_name.$error"
                :value="$v.delivery.receiver_middle_name.$model"
                v-on:change-input="(e) => {changeInput('delivery', 'receiver_middle_name', e)}"
              )
            .form__row.form__row-middle-name
              TextInput(
                type='text'
                :label="$t('whereDelivery.labels.phone')"
                :error="$v.delivery.receiver_phone.$error"
                :value="$v.delivery.receiver_phone.$model"
                v-mask="'+380 ## ### ## ##'"
                v-on:change-input="(e) => {changeInput('delivery', 'receiver_phone', e)}"
              )
            footer.form__footer
              a.link-back(@click="step = 'deliverySend'") {{ $t('whereDelivery.buttons.back') }}
              button.button.form__submit(
                :disabled="$v.deliveryGroup.$invalid"
                @click= " toContacts "
              ) {{ $t('request.buttons.continue') }}
    // step 4
    main.main.main_contact(v-else)
      header.main__header
        h1.main__title {{ $t('request.contact.title') }}
      .main__container
        .main__content
          .form.form_contact
            .form__row.form__row_1
              .form__row_1-1
                TextInput(
                  :label="$t('request.contact.labels.name')"
                  :error="$v.contact.first_name.$error"
                  :value="$v.contact.first_name.$model"
                  v-on:change-input="(value) => changeInput('contact', 'first_name', value)"
                )
              .form__row_1-2
                TextInput(
                  :label="$t('request.contact.labels.secondName')"
                  :value="$v.contact.last_name.$model"
                  v-on:change-input="(value) => changeInput('contact', 'last_name', value)"
                )
            .form__row
              TextInput(
                :label="$t('request.contact.labels.email')"
                :error="$v.contact.email.$error"
                :errorText="$t('request.contact.errors.email')"
                :value="$v.contact.email.$model"
                v-on:change-input="(value) => changeInput('contact', 'email', value)"
              )
            .form__row
              label.form__label(v-html="$t('request.contact.labels.phone')")
              .form__field
                input.form__input(
                  type="text"
                  v-model="$v.contact.phone.$model"
                  v-mask="'+380 ## ### ## ##'"
                  :class="{'form__input_error': $v.contact.phone.$error}"
                )
                span.form__error-text(v-if='$v.contact.phone.$error') {{ $t('request.contact.errors.phone') }}
            footer.form__footer
              a.link-back(@click="step = delivery_type ? 'deliverySend': 'delivery'") {{ $t('request.buttons.back') }}
              button.button.form__submit(
                :disabled="$v.contactGroup.$invalid || formSubmited"
                @click="submitForm"
              ) {{ $t('request.buttons.submit') }}
            .form__row
              Checkbox(
                :label="$t('request.contact.checkbox')"
                v-on:handleChange="contact.agreement = !contact.agreement"
                :checked="contact.agreement"
                id="contact-agreement"
              )
</template>

<script>
import { theme } from '@/thems'
import { ThemeProvider } from 'vue-styled-components'
import { RadioButton } from '@/components/RadioButton'
import { Checkbox } from '@/components/Checkbox'
import { TextInput } from '@/components/TextInput'
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { required, email, helpers, sameAs, minLength } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapGetters } from 'vuex'
import { api } from '@/store/http-common'
import Uploader from '@/components/Uploader'

const objectToFormData = require('object-to-formdata')
const phoneRegex = helpers.regex('+380 44 555 55 55', /^\+380 \d{2} \d{3} \d{2} \d{2}$/)

Vue.component('v-select', vSelect)

export default {
  name: 'ServiceProductRepair_ServiceRequest',
  data () {
    return {
      loading: false,
      theme: theme,
      step: 'reason',
      options: ['неисправность', 'диагностика', 'техническое обслуживание'],
      optionsNp: [],
      optionsCities: [],
      cityNextPage: false,
      warehousePage: 1,
      warehousePhrase: '',
      cityObserver: null,
      warehouseObserver: null,
      phrase: '',
      reason: {
        title: '',
        description: '',
        agreement: true
      },
      receive_type: 'newpost',
      delivery_type: false,
      contact: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        agreement: true
      },
      delivery: {
        receiver_first_name: '',
        receiver_last_name: '',
        receiver_middle_name: '',
        receiver_phone: '',
        city: {
          code: '',
          title: ''
        },
        warenhouse: {
          code: '',
          title: ''
        }
      },
      files: '',
      formSubmited: false,
      debounce: null,
      infScrollLoading: false
    }
  },
  directives: {
    mask
  },
  validations: {
    phrase: {
      required,
      minLength: minLength(3)
    },
    reason: {
      title: {
        required
      },
      description: {
        required
      },
      agreement: {
        sameAs: sameAs(() => true)
      }
    },
    contact: {
      first_name: {
        required
      },
      email: {
        email
      },
      phone: {
        required,
        phoneRegex
      },
      last_name: {},
      agreement: {
        sameAs: sameAs(() => true)
      }
    },
    delivery: {
      warenhouse: {
        title: {
          required,
          minLength: minLength(2)
        }
      },
      city: {
        title: {
          required,
          minLength: minLength(2)
        }
      },
      receiver_first_name: {
        required
      },
      receiver_last_name: {
        required
      },
      receiver_middle_name: {
        required
      },
      receiver_phone: {
        required
      }
    },
    deliveryGroup: ['delivery.warenhouse', 'delivery.city', 'delivery.receiver_first_name', 'delivery.receiver_last_name', 'delivery.receiver_middle_name', 'delivery.receiver_phone'],
    reasonGroup: ['reason.title', 'reason.description', 'reason.agreement'],
    contactGroup: ['contact.first_name', 'contact.email', 'contact.phone', 'contact.agreement']
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      // хак, щоб this.seriesNumber витягнувся з localStorage
      await this.$store.dispatch('getLS')

      await this.$store.dispatch('getProduct', this.seriesNumber)
    },
    changeFiles (files) {
      this.files = files
    },
    changeInput (step, field, value) {
      this[step][field] = value
      this.$v[step][field].$touch()
    },
    submitForm () {
      this.formSubmited = true
      // Request post and get trackingNumber
      let data = objectToFormData({
        delivery: this.getDeliveryData(),
        receive_type: this.receive_type,
        delivery_type: this.delivery_type ? this.receive_type : 'newpost',
        contact: this.contact,
        reason: this.reason,
        product_imei: this.seriesNumber,
        pictures: this.files
      })
      api
        .post('ajax.php?action=sg:service.api.repairrequest.add', data)
        .then(response => {
          if (response.data.status === 'success') {
            this.$store.dispatch('updateTrackingNumber', response.data.data.tracking_code)
          }
          this.formSubmited = false
        }, error => {
          console.log(error)
        })
    },
    async citySearch (search) {
      if (search && search.length > 3) {
        clearTimeout(this.debounce)
        this.debounce = setTimeout(async () => {
          this.phrase = search
          let data = new FormData()
          data.append('phrase', this.phrase)
          const response = await api.post(`ajax.php?action=sg:service.api.address.findNpCity&page=1`, data)
          if (response.data.status === 'success') {
            this.optionsCities = response.data.data.CITIES
            this.cityNextPage = response.data.data.NEXT_PAGE
          } else {
            this.cityNextPage = false
            this.options = []
          }
        }, 600)
      }
    },
    setActiveCity (city) {
      this.delivery.city = city
      this.$v.delivery.warenhouse.$touch()
      let data = new FormData()
      data.append('city', city.code)
      api
        .post('ajax.php?action=sg:service.api.address.getNpWarenhouses', data)
        .then(response => {
          this.optionsNp = response.data.data
          this.delivery.warenhouse = this.optionsNp[0]
          this.$v.delivery.warenhouse.$touch()
          this.warehousePage = 1
        })
    },
    setActiveNp (value) {
      if (value) {
        this.delivery.warenhouse = value
        this.$v.delivery.warenhouse.$touch()
      }
    },
    toContacts () {
      this.contact.first_name = this.contact.first_name.length > 0 ? this.contact.first_name : this.delivery.receiver_first_name
      this.contact.last_name = this.contact.last_name.length ? this.contact.last_name : this.delivery.receiver_last_name
      this.contact.phone = this.contact.phone.length ? this.contact.phone : this.delivery.receiver_phone
      this.step = 'contact'
    },
    getDeliveryData () {
      return {
        warenhouse: this.delivery.warenhouse,
        city: this.delivery.city,
        receiver_name: [this.delivery.receiver_first_name, this.delivery.receiver_middle_name, this.delivery.receiver_last_name].join(' '),
        receiver_phone: this.delivery.receiver_phone
      }
    },
    warehouseSearch (value) {
      this.warehousePhrase = value
    },
    async cityScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        console.log(this.phrase)
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        let data = new FormData()
        data.append('phrase', this.phrase)
        this.infScrollLoading = true
        const response = await api.post(`ajax.php?action=sg:service.api.address.findNpCity&page=${this.cityNextPage}`, data)
        if (response.data.status === 'success') {
          this.optionsCities = [...this.optionsCities, ...response.data.data.CITIES]
          this.cityNextPage = response.data.data.NEXT_PAGE
        } else {
          this.options = []
          this.cityNextPage = false
        }
        this.infScrollLoading = false
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async cityOpen () {
      console.log('open')
      await this.$nextTick()
      this.cityObserver.observe(this.$refs.cityLoad)
    },
    cityClose () {
      this.cityObserver.disconnect()
    },
    async warehouseInfScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.warehousePage = this.warehousePage + 1
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async warehouseOpen () {
      await this.$nextTick()
      this.warehouseObserver.observe(this.$refs.warehouseLoad)
    },
    warehouseClose () {
      this.warehouseObserver.disconnect()
    }
  },
  computed: {
    ...mapGetters({
      product: 'getProduct',
      seriesNumber: 'getSeriesNumber'
    }),
    isDisabled () {
      return this.$v.$invalid
    },
    filteredWarehouses () {
      return this.optionsNp.filter(item => item.title.includes(this.warehousePhrase))
    },
    paginatedWarehouses () {
      return this.filteredWarehouses.slice(0, this.warehousePage * 20)
    }
  },
  components: {
    RadioButton,
    Checkbox,
    TextInput,
    Uploader,
    'theme-provider': ThemeProvider
  },
  mounted () {
    this.warehouseObserver = new IntersectionObserver(this.warehouseInfScroll)
    this.cityObserver = new IntersectionObserver(this.cityScroll)
  }
}
</script>

<style lang="scss" >
.disabled-delivery-button {
  width: calc((100% - 8px) / 2);
  max-width: 224px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  padding: 0 5px;
  background-color: #fff;
  color: #1d1d1b;
  font-family: 'Gilroy';
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  cursor: initial;
  opacity: 0.6;
}

.loading {
  height: 3px;
  margin-bottom: -4px;
  width: 100%;
  background: linear-gradient(#3c3c3c42, #3c3c3c42) left/0% 100% no-repeat;
  animation: anim 2s ease-in-out infinite alternate;
}

.custom-select {
  .vs__dropdown-menu {
    max-height: 243px;
  }
}

@keyframes anim {
  0% {
    background-size: 0% 100%;
    background-position: left;
  }
  50% {
    background-size: 70% 100%;
  }
  100% {
    background-size: 0% 100%;
    background-position: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceProductRepair_ServiceRequest.vue